/**
 * SIR (Self-Insured Retention) credit tiers — backed by the real
 * `GET /v2/credit-factors/sir` endpoint (orion-backend).
 *
 * Used by the Schedule's live pricing calc:
 *     SIR Adj Premium = Mat Adj Premium × (1 − sirCredit)
 *
 * Higher retentions yield larger credits because the insured covers
 * more risk before the carrier pays out.
 *
 * The backend row shape (`SirCreditFactor`: `sir_amount` + `credit`)
 * is adapted here to the FE `SirCreditTier` (`retention` + `credit`)
 * that `domain/pricing` consumes. The backend table includes a
 * `{ sir_amount: 0, credit: 0 }` tier — a $0 deductible is a valid
 * selection that resolves to a 0% credit (see `lookupSirCredit`).
 */
import type { SirCreditTier } from "../../domain/pricing";
import { getJsonReal } from "../client";

export interface SirCreditsResponse {
    tiers: SirCreditTier[];
}

/** Backend SIR credit-factor row — mirrors `SirCreditFactor`. */
interface SirCreditFactorWire {
    sir_amount: number;
    credit: number;
}

export function getSirCredits(): Promise<SirCreditsResponse> {
    return getJsonReal<SirCreditFactorWire[]>("/v2/credit-factors/sir").then((rows) => ({
        tiers: rows.map((r) => ({ retention: r.sir_amount, credit: r.credit })),
    }));
}
